import { createContext } from "react";

export interface PaymentContextState {
  isPaid: boolean | null;
  icId: number | null;
  countryId: number | null;
  isChecking: boolean;
  lastCheckedAt?: number;
  refreshPaymentStatus: () => Promise<void>;
}

const PaymentContext = createContext<PaymentContextState>({
  isPaid: null,
  icId: null,
  countryId: null,
  isChecking: false,
  refreshPaymentStatus: async () => {}
});

export default PaymentContext;


